import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Navigation from '../views/Navigation.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/',
    name: 'Navigation',
    component: Navigation,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        name: 'users',
        path: 'users',
        component: () => import('../views/Profiles.vue')
      },
      {
        name: 'repliesLog',
        path: 'repliesLog',
        component: () => import('../views/RepliesLog.vue')
      },
      {
        name: 'forms',
        path: 'forms',
        component: () => import('../views/Forms.vue')
      },
      {
        name: 'formReply',
        path: 'form-reply/:id',
        component: () => import('../views/FormReply.vue')
      },
      {
        name: 'answerEdit',
        path: 'form-reply/:id/:replyId',
        component: () => import('../views/FormReply.vue')
      },
      {
        name: 'repliesList',
        path: 'form-replies-list/:id/:uid',
        component: () => import('../views/FormRepliesList.vue')
      },
      {
        path: '*',
        component: () => import('../views/Forms.vue')
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
